export enum Gender {
  FEMALE = 'female',
  MALE = 'male',
}

export enum CalendarType {
  OPEN_DAYS = 'open_days',
  CALENDAR_DAYS = 'calendar_days',
}
